// An item's price history chart on its Einkauf tab (docs/suppliers.md, "Preisverlauf").
export default {
  title: "Preisverlauf",
  // Unter dem Titel, die Einheit der Achse dahinter („Preis je Lieferant in EUR / t“).
  subtitle: "Preis je Lieferant in",
  // Die Zeiträume des Umschalters; immer mehrere Monate.
  months: "{n} Monate",
  period: "Zeitraum",
  currency: "Währung",
  today: "Heute",
  // Das Band hinter heute: Preise, die schon für einen späteren Tag eingetragen sind.
  upcoming: "kommt noch",
  empty: "Keine Preise in diesem Zeitraum",
  // Im Hinweis, wo eine Zeile ab einem Tag keinen Betrag in der gezeigten Währung hat; die Währung setzt die
  // Komponente dahinter („kein Preis in EUR“).
  no_price_in: "kein Preis in",
  aria: "Preisverlauf je Lieferant",
  // Hinter einer Linie, wenn die Zeilen einer Maschine in verschiedenen Einheiten abrechnen: „Mietpark Nord (je Wo)“.
  per: "je",
  // Unter der Legende, die Zeilen dahinter im Code: Zeilen je Woche oder Monat neben Stunden werden nicht gezeichnet.
  other_unit: "Andere Einheit, nicht gezeigt:",
}
